// Modal de instalación del tema (pasos + validador de CP).
//
// La cobertura sale de las ZONAS del backend — la misma lógica que la PDP de
// mantenimiento (fx-mantenimiento.liquid): GET /maintenance/availability?zip=
// resuelve la zona del CP; `zone: null` = sin cobertura. Antes era una lista
// fija aquí (CDMX 01000–16999 + 319 CPs de Edomex); con las zonas, Edomex
// queda sin cobertura (decisión del usuario, 2026-10-09). Agregar/quitar
// cobertura = editar zonas en el dashboard, no este archivo.
//
// Solo valida cobertura (hay zona), no que haya horarios libres: el horario se
// elige después en la PDP del servicio.

var FX_INSTALL_API_URL = "https://toa-tracking-project-production.up.railway.app";

let stepsCircles = document.querySelectorAll(".step-installment__circle");
let stepsDivs = document.querySelectorAll(".installation-steps-div");
let stepIndicator = document.getElementById("step-indicator");
let currentStep = 1;
function prevStep() {
  document.getElementById("next-step-btn").style.display = "block";
  if (currentStep > 1) {
    stepsCircles[currentStep - 1].classList.remove("step-installment__active");
    for (let i = 0; i < stepsDivs.length; i++) {
      stepsDivs[i].style.display = "none";
    }
    stepsDivs[currentStep - 2].style.display = "block";
    currentStep--;
    stepsCircles[currentStep - 1].classList.add("step-installment__active");
    stepIndicator.setAttribute("data-step-active", currentStep);
  }
  if (currentStep === 1) {
    document.getElementById("prev-step-btn").style.backgroundColor = "#ccc";
    document.getElementById("prev-step-btn").style.color = "#333";
  }
}
function nextStep() {
  document.getElementById("prev-step-btn").style.backgroundColor = "#76bc43";
  document.getElementById("prev-step-btn").style.color = "#fff";
  if (currentStep < stepsCircles.length) {
    stepsCircles[currentStep - 1].classList.remove("step-installment__active");
    for (let i = 0; i < stepsDivs.length; i++) {
      stepsDivs[i].style.display = "none";
    }
    stepsDivs[currentStep].style.display = "block";
    currentStep++;
    stepsCircles[currentStep - 1].classList.add("step-installment__active");
    stepIndicator.setAttribute("data-step-active", currentStep);
    if (currentStep === stepsCircles.length) {
      document.getElementById("next-step-btn").style.display = "none";
    } else {
      document.getElementById("next-step-btn").style.display = "block";
    }
  }
}

// // Registro de CPs consultados (webhook externo). No bloquea la validación.
// function logPostalCode(code) {
//   fetch("https://jeff-uxui.xyz/webhook/4f4caa29-4e91-42e1-9eca-1181a76f570c", {
//     method: "POST",
//     body: JSON.stringify({
//       zip: parseInt(code, 10),
//       source: window.location,
//     }),
//     headers: {
//       "content-type": "application/json",
//     },
//   })
//     .then((res) => res.json())
//     .then((data) => {
//       console.info("ZIP was saved successful", data);
//     })
//     .catch(() => {
//       console.error("ZIP could be saved");
//     });
// }

function validatePostalCode() {
  let code = document.getElementById("postal-code").value.trim();
  let message = document.getElementById("postal-code-message");
  let btn = document.getElementById("btn-validador");
  let nextBtn = document.getElementById("next-step-btn");

  // Cada validación empieza sin cobertura: un CP válido seguido de uno
  // inválido no debe dejar el siguiente paso habilitado.
  nextBtn.disabled = true;

  if (!/^\d{5}$/.test(code)) {
    message.textContent = "Ingresa un código postal válido de 5 dígitos.";
    message.style.color = "#e74c3c";
    return;
  }

  btn.disabled = true;
  btn.innerHTML = "Validando...";

  fetch(FX_INSTALL_API_URL + "/maintenance/availability?zip=" + encodeURIComponent(code))
    .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
    .then((res) => {
      if (res.data && res.data.zone) {
        nextBtn.disabled = false;
        message.textContent = "¡Sí contamos con instalación en tu zona!";
        message.style.color = "#76bc43";
      } else {
        message.textContent = "Por ahora no tenemos cobertura en tu zona.";
        message.style.color = "#e74c3c";
      }
    })
    .catch(() => {
      message.textContent = "No pudimos validar tu código postal. Intenta de nuevo en unos momentos.";
      message.style.color = "#e74c3c";
    })
    .finally(() => {
      btn.disabled = false;
      btn.innerHTML = "Validar";
    });
}

function toggleStepIcon(step) {
  var checkbox = document.getElementById("step" + step);
  var iconSpan = document.getElementById("icon-step" + step);
  if (checkbox.checked) {
    iconSpan.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#76bc43"/>
          <path d="M7 13l3 3 7-7" stroke="#fff" stroke-width="2" fill="none"/>
        </svg>`;
  } else {
    iconSpan.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#ccc"/>
          <path d="M7 13l3 3 7-7" stroke="#fff" stroke-width="2" fill="none"/>
        </svg>`;
  }
}
